export { default } from './getScrollbarSize';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/getScrollbarSize/index.js
// module id = 753
// module chunks = 22